import { createContext, Dispatch, SetStateAction } from 'react';
import utils from 'utils';
import { DataRoom } from '../../models/DataRoom';
import { DataRoomNode } from '../../models/DataRoomNode';
import { QAndARoles, QAndASides } from '../../models/QAndA';
import {
  DataRoomMemberRole,
  PreviousGroupChats,
} from '../../models/DataRoomMember';
import { BulkAvailabilityFileSettings } from '../../models/DataRoomBulk';
import {
  DATA_ROOM_DASHBOARD_TIMEFRAME,
  DataRoomDashboardTimeframe,
} from '../../models/Dashboard';
import { DataRoomFaqAccessGranularityData } from '../../models/FAQ';
import {
  ANALYTICS_TIMEFRAME,
  AnalyticsTimeframe,
} from '../../subrouters/Reports/pages/Reports/types';

type DataRoomContextValues = {
  isAdmin: boolean;
  isQaAdmin: boolean;
  isOwner: boolean;
  dataRoom: DataRoom;
  role: DataRoomMemberRole;
  qaRole: QAndARoles;
  qaSide: QAndASides;
  preferredDashboardTimeframe: DataRoomDashboardTimeframe;
  isPublishingAllowed: boolean;
  canBuyerAskQuestion: boolean;
  canUserAskQuestion: boolean;
  canUserManageQuestionSubject: boolean;
  questionSubjects: string[];
  isClosedDataRoom: boolean;
  isDisabledDataRoom: boolean;
  isDisabledQA: boolean;
  refetchFlag: boolean;
  hasIndexGenerated: boolean;
  doesntHaveAccess: boolean;
  isEnterpriseHead: boolean;
  isSellSide: boolean;
  isBuySide: boolean;
  doesUserHaveAccessToQa: boolean;
  canUserCreateShareableLinks: boolean;
  canUserAddFAQ: boolean;
  canUserManageNda: boolean;
  faqAccessData: DataRoomFaqAccessGranularityData;
  fileSettingsInitialValues: BulkAvailabilityFileSettings;
  isFaqAccessLoading: boolean;
  canAccessQaSettings: boolean;
  hasSeenDataRoomOnboarding: boolean;
  preferredAnalyticsTimeframe: AnalyticsTimeframe;
  isPrefferedSummarisedView: boolean;
  openBuyQaDrawer: () => void;
  refetch: () => void;
  setDataRoom: Dispatch<SetStateAction<DataRoom>>;
  setSelectedForQAndADrawerForDrawer: Dispatch<SetStateAction<DataRoomNode>>;
  openChatDrawer: (
    sessionId?: string,
    groupChatSessionId?: string,
    previousGroupChats?: PreviousGroupChats,
  ) => void;
};

export default createContext<DataRoomContextValues>({
  isAdmin: false,
  isQaAdmin: false,
  isOwner: false,
  role: null,
  qaRole: null,
  qaSide: null,
  preferredDashboardTimeframe: DATA_ROOM_DASHBOARD_TIMEFRAME.TODAY,
  preferredAnalyticsTimeframe: ANALYTICS_TIMEFRAME.OVERALL,
  isPrefferedSummarisedView: false,
  dataRoom: null,
  isPublishingAllowed: false,
  canBuyerAskQuestion: false,
  canUserAskQuestion: false,
  canUserManageQuestionSubject: false,
  questionSubjects: [],
  isClosedDataRoom: false,
  isDisabledDataRoom: false,
  isDisabledQA: false,
  refetchFlag: false,
  hasIndexGenerated: false,
  doesntHaveAccess: false,
  isEnterpriseHead: false,
  isSellSide: false,
  isBuySide: false,
  doesUserHaveAccessToQa: true,
  canUserCreateShareableLinks: false,
  canUserAddFAQ: false,
  canUserManageNda: false,
  faqAccessData: null,
  fileSettingsInitialValues: null,
  isFaqAccessLoading: false,
  canAccessQaSettings: false,
  hasSeenDataRoomOnboarding: true,
  openBuyQaDrawer: utils.noop,
  refetch: utils.noop,
  setDataRoom: utils.noop,
  setSelectedForQAndADrawerForDrawer: utils.noop,
  openChatDrawer: utils.noop,
});
